module.exports = __webpack_public_path__ + "static/img/exam-7-bg.430cdb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-7-bg.png
// module id = xz6w
// module chunks = 1